import { useEffect, useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import { Pagination } from 'antd';
import styled from 'styled-components';

import VideoPlayerPop from '../about/components/VideoPlayerPop';

const BrandListStyle = styled.section`
  .brand-item {
    position: relative;
    border: 1px solid #eee;
    border-top: none;
    border-right: none;
    &:hover {
      &::after {
        width: 100%;
      }
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      height: 100%;
      width: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;

const AgentContent = ({ mallData, agentData }) => {
  const [videoData, setVideoData] = useState(null);
  const [asyncAgentData, setAsyncAgentData] = useState(null);
  const [brandKw, setBrandKw] = useState(null);

  function handlePlayVideo({ way, url, poster }) {
    setVideoData({ way, url, poster });
  }
  function handleInputChange(e) {
    const { target } = e;
    setBrandKw(target.value);
  }
  function getAgentBrandList(page, kw = '') {
    sendAxios({
      method: 'get',
      url: `www/agent?currentPage=${page}&keyWord=${kw}`,
      baseURL: Domains.lcscWwwUrl,
    }).then(async (res) => {
      if (res.code === 200) {
        setAsyncAgentData(res.result);
      }
    });
  }
  function pageChange(page) {
    getAgentBrandList(page, brandKw || '');
  }
  function handleClickSearch() {
    getAgentBrandList(1, brandKw || '');
  }
  useEffect(() => {
    setAsyncAgentData(agentData);
  }, []);

  const handleSearchInputKeyDown = (e) => {
    const { keyCode } = e;
    // 监听回车
    if (keyCode === 13) {
      handleClickSearch();
    }
  };

  return (
    <>
      {videoData && <VideoPlayerPop {...videoData} setVideoData={setVideoData} />}
      <section
        className="max-w-[3840px] h-[450px] flex justify-center items-center"
        style={{
          background: `url(${
            mallData.agentData.surfacePlotPictureUrl ||
            '//static.szlcsc.com/ecp/assets/web/static/images/about/companyprofile.png'
          }) center center no-repeat`,
          backgroundSize: 'auto 100%',
        }}
      >
        {mallData.agentData.uploadType === 'video' && (
          <img
            src="//static.szlcsc.com/ecp/assets/web/page/www/about/images/play-btn.svg"
            className="cursor-pointer"
            onClick={() =>
              handlePlayVideo({
                way: mallData.agentData.uploadWay,
                url: mallData.agentData.fileUrl,
                poster:
                  mallData.agentData.surfacePlotPictureUrl ||
                  '//static.szlcsc.com/ecp/assets/web/static/images/about/companyprofile.png',
              })
            }
          />
        )}
      </section>
      <section className="bg-white w-full text-center">
        <section className="max-w-[1200px] pb-[39px] pt-[20px] mx-auto">
          <section className="mx-auto w-[367px] h-[42px] flex justify-center">
            <input
              className="w-[324px] h-full indent-[8px] text-[14px] border-solid border-[2px] border-lcBlue rounded-l-[4px] outline-none"
              placeholder="请输入品牌名称查询代理品牌"
              autoComplete="off"
              maxLength={53}
              type="text"
              onKeyDown={handleSearchInputKeyDown}
              onChange={handleInputChange}
            />
            <button onClick={handleClickSearch} className="w-[43px] h-full bg-lcBlue text-white rounded-r-[4px]">
              <SearchOutlined style={{ fontSize: '25px' }} />
            </button>
          </section>
          {asyncAgentData && asyncAgentData?.agentBrandList?.length > 0 && (
            <BrandListStyle
              className="max-w-[1000px] mx-auto my-[20px] flex flex-wrap border border-solid border-[#eee] border-l-0 border-b-0"
              data-spm="br"
            >
              {asyncAgentData.agentBrandList.map((brand, idx) => (
                <li
                  key={idx}
                  className="brand-item custom-group w-[33.33%] h-[333px] flex justify-center items-center relative"
                >
                  <img
                    alt={brand.brandName}
                    className="custom-group-hover-opacity-10 !max-w-[252px] max-h-[272px]"
                    src={`${Domains.lcscImageUrl}${brand.agentCertImgUrl}`}
                  />
                  <div className="absolute z-[2] hidden custom-group-hover-block text-center m-auto text-white">
                    <p className="text-[16px]">{brand.brandName}</p>
                    <a
                      data-spm={idx + 1}
                      className="mx-auto block w-[115px] h-[40px] bg-lcBlue my-[20px] leading-[40px] font-bold hover:text-white hover:opacity-80 rounded-[3px] text-[16px]"
                      target="_blank"
                      href={`${Domains.lcscListUrl}/brand/${brand.brandId}.html`}
                    >
                      查看产品
                    </a>
                  </div>
                </li>
              ))}
            </BrandListStyle>
          )}
          {asyncAgentData && asyncAgentData?.agentBrandList?.length > 0 ? (
            <Pagination
              defaultCurrent={1}
              defaultPageSize={24}
              current={asyncAgentData.page.currPage}
              simple
              total={asyncAgentData.page.totalRow}
              onChange={pageChange}
            ></Pagination>
          ) : (
            <p className="text-center h-[300px] mt-[30px] text-[14px] w-full">暂无结果</p>
          )}
        </section>
      </section>
    </>
  );
};

export default AgentContent;
